import { Fragment } from 'react';
import { Link } from 'react-router';
import { Sheet } from '../pages/posParts';
import { useBackButton } from '../pos/backButton';
import { Icon } from './icons';
import type { MoreSection } from './navModel';

/**
 * „⋯ Mehr“ der App (U13): Blatt von unten mit den weiteren Bereichen. Oben die Bereiche des aktuellen Basars (nach Recht),
 * darunter Anmeldungen, Einsätze, Profil und Einstellungen (`navModel`). Das Blatt ist nur eingehängt, solange es offen
 * ist; die Zurück-Taste der App schließt es (statt die Seite zu verlassen). Eintrag antippen schließt es ebenfalls.
 * Die Bereiche des Basars sind nach Gruppen (Vorbereitung, Basartag, …) mit Überschrift geordnet.
 */
export function MoreSheet({
  sections,
  onClose,
}: {
  sections: readonly MoreSection[];
  onClose: () => void;
}) {
  useBackButton(onClose);
  return (
    <Sheet title="Mehr" onClose={onClose}>
      <nav className="more" aria-label="Weitere Bereiche">
        {sections
          .filter((section) => section.entries.length > 0)
          .map((section) => (
            <section key={section.key} className="more__section" aria-label={section.title}>
              <h3 className="more__heading">{section.title}</h3>
              <ul className="more__list">
                {section.entries.map((entry, index) => (
                  <Fragment key={entry.key}>
                    {entry.group !== undefined &&
                      entry.group !== section.entries[index - 1]?.group && (
                        <li className="more__group">
                          <h4 className="more__subheading">{entry.group}</h4>
                        </li>
                      )}
                    <li>
                      <Link className="more__link" to={entry.to} onClick={onClose}>
                        <Icon name={entry.icon} size={22} />
                        <span className="more__text">
                          <span className="more__label">{entry.label}</span>
                          {entry.description !== undefined && (
                            <span className="more__desc muted">{entry.description}</span>
                          )}
                        </span>
                        <Icon name="chevron-right" size={18} />
                      </Link>
                    </li>
                  </Fragment>
                ))}
              </ul>
            </section>
          ))}
      </nav>
    </Sheet>
  );
}
